import { render, staticRenderFns } from "./InspectionStepBody.vue?vue&type=template&id=60fbac8b&scoped=true"
import script from "./InspectionStepBody.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionStepBody.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionStepBody.vue?vue&type=style&index=0&id=60fbac8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fbac8b",
  null
  
)

export default component.exports